import { useNavigate } from 'react-router-dom';

import ImageWithFallback from '@App/components/ImageWithFallback/ImageWithFallback';
import DefinitionComponent from '@App/components/DefinitionComponent/DefinitionComponent';

import { GLOSSARY_ITEMS } from '@App/components/Navbar/GlossarySearch/glossary-search.constants';
import { usePublishedAdaptationStories } from '@services/query.service';
import { getImageUrl, getPlaceholderImageUrl } from '@services/utils.service';
import { useTranslation } from '@utils/i18n/i18n.consumers';

import { getStoriesForCategories } from './risk-data-stories.utils';

import './risk-data-stories.styl';

function RiskDataStories({ hazardCategories }) {
  const { data: stories } = usePublishedAdaptationStories();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const storiesForCategory = getStoriesForCategories(stories, hazardCategories);

  if (!storiesForCategory.length) {
    return null;
  }

  return (
    <div className="risk-data-stories">
      <p>
        {t('Take a look at the possible ')}
        <DefinitionComponent
          id={1}
          term="Adaptation"
          definition={GLOSSARY_ITEMS.find(item => item.id === 1)?.description}
          learnMoreUrl={GLOSSARY_ITEMS.find(item => item.id === 1)?.url}
          lowercase
        />
        {t(' stories listed below.')}
      </p>
      <div className="risk-data-stories__stories">
        {storiesForCategory.map((story) => {
          return (
            <div
              className="risk-data-stories__stories__story z-depth-1"
              onClick={() => navigate(`/adaptation/stories/${story?.id}`)}
              key={story?.id}
            >
              <ImageWithFallback
                className="risk-data-stories__stories__story__img"
                src={getImageUrl(story)}
                fallbackSrc={getPlaceholderImageUrl(story)}
                alt={story?.translations?.en?.title || 'Story image'}
              />
              <div className="risk-data-stories__stories__story__content">
                <div className="risk-data-stories__stories__story__content__title ellipsis">
                  {story?.translations?.en?.title}
                </div>
                <div className="risk-data-stories__stories__story__content__description">
                  {story?.translations?.en?.description}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default RiskDataStories;